import { Settings } from "./Settings";
import {
    ICheckOptions,
    IReelTeasingAttributes,
    ISymbolTeasingAttributes,
    ReelTeasingActions,
    SymbolTeasingActions,
    TeasingComponent,
} from "./TeasingComponent";
import { PlayList } from "../Components/Sounds/PlayList";

/**
 * @author Marek Turkovic
 */
export class TeasingBonus extends TeasingComponent {
    constructor() {
        super();

        //this.teasingStopDelay = 90;
        this.minimumSymbolsForTeasing = 2;

        this.teasingSymbol = Settings.SymbolDragonsGate;
    }

    set customData(value: any) {}

    //******************************************************************************************************************
    //  CHECK REELS
    //******************************************************************************************************************

    /**
     * Check called before reel.spinStop(). Checks if teasing is possible and checks which reel can be stopped immediatly.
     * @param {ICheckOptions} options
     */
    public checkOnInit(options: ICheckOptions): Array<IReelTeasingAttributes> {
        this.stoppedSymbolsArray = options.stoppedSymbols;
        this.force = options.force;
        let aditionalDelay = 0;

        if (options.force) {
            this.teasingEnabled = false;
        } else {
            if (this.isEnoughtForStartTeasing(0, 1)) {
                this.teasingEnabled = true;
            } else {
                this.teasingEnabled = false;
            }
        }

        if (!this.teasingEnabled) {
            if (this.elementInstance["teasingFront"] != null) {
                this.elementInstance["teasingFront"].goToCase("NORMAL");
            }
            if (this.elementInstance["teasingParticles"] != null) {
                this.elementInstance["teasingParticles"].goToCase("NORMAL");
            }
        }

        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            //this.reelsTeasingAttributes[reelIndex].action = this.isReelTeasable(reelIndex) ? ReelTeasingActions.TEASE : ReelTeasingActions.DO_NOTHING;

            /*if (options.force) {
                this.reelsTeasingAttributes[reelIndex].stopping = true;
            }*/

            switch (reelIndex) {
                case 0:
                    this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;

                    break;
                case 1:
                    this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay;

                    break;
                case 2:
                    if (
                        this.firstOccurrenceOfSymbolOnReel(0, this.teasingSymbol) !== -1 &&
                        this.firstOccurrenceOfSymbolOnReel(1, this.teasingSymbol) !== -1
                    ) {
                        aditionalDelay += this.teasingStopDelay;
                        this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.TEASE;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                    }
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + aditionalDelay;
                    break;
                case 3:
                    if (
                        this.firstOccurrenceOfSymbolOnReel(0, this.teasingSymbol) !== -1 &&
                        this.firstOccurrenceOfSymbolOnReel(1, this.teasingSymbol) !== -1 &&
                        this.firstOccurrenceOfSymbolOnReel(2, this.teasingSymbol) !== -1
                    ) {
                        aditionalDelay += this.teasingStopDelay;
                        this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.TEASE;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                    }
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + aditionalDelay;
                    break;
                case 4:
                    if (
                        this.firstOccurrenceOfSymbolOnReel(0, this.teasingSymbol) !== -1 &&
                        this.firstOccurrenceOfSymbolOnReel(1, this.teasingSymbol) !== -1 &&
                        this.firstOccurrenceOfSymbolOnReel(2, this.teasingSymbol) !== -1 &&
                        this.firstOccurrenceOfSymbolOnReel(3, this.teasingSymbol) !== -1
                    ) {
                        aditionalDelay += this.teasingStopDelay;
                        this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.TEASE;
                    } else {
                        this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                    }
                    this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + aditionalDelay;
                    break;
            }
        }

        return this.reelsTeasingAttributes;
    }

    /**
     *
     * @param {number} reelIndexStart
     * @param {number} reelIndexStop
     * @returns {boolean}
     */
    protected isEnoughtForStartTeasing(reelIndexStart: number = 0, reelIndexStop: number): boolean {
        return this.countSymbols(reelIndexStart, reelIndexStop, this.teasingSymbol) >= this.minimumSymbolsForTeasing;
    }

    /**
     *
     * @param {number} reelIndex
     * @returns {boolean}
     */
    /*protected isReelTeasable(reelIndex: number): boolean {
        return this.teasingEnabled && reelIndex >= 2;
    }*/

    //******************************************************************************************************************
    //  CHECK SYMBOLS TEASING
    //******************************************************************************************************************

    /**
     *
     * @param {number} reelIndex
     * @returns {Array<ISymbolTeasingAttributes>}
     */
    public checkSymbolsPerReel(reelIndex: number): Array<Array<ISymbolTeasingAttributes>> {
        if (this.teasingEnabled) {
            let countOfSymbol = this.getCountSymbolsOnReelsAndRows(0, reelIndex, this.teasingSymbol);
            /*
            0 - nowin
            1 - normal
            2 - impact
            3 - tease
            */
            switch (reelIndex) {
                case 0:
                    if (countOfSymbol > 1) {
                        for (let j = 0; j < this.stoppedSymbolsArray[reelIndex].symbols.length; j++) {
                            if (this.stoppedSymbolsArray[reelIndex].symbols[j]) {
                                if (this.stoppedSymbolsArray[reelIndex].symbols[j] === this.teasingSymbol) {
                                    this.symbolsTeasingAttributes[reelIndex][j].action = SymbolTeasingActions.TEASE;
                                }
                            }
                        }
                    } else if (countOfSymbol == 1) {
                        for (let j = 0; j < this.stoppedSymbolsArray[reelIndex].symbols.length; j++) {
                            if (this.stoppedSymbolsArray[reelIndex].symbols[j]) {
                                if (this.stoppedSymbolsArray[reelIndex].symbols[j] === this.teasingSymbol) {
                                    this.symbolsTeasingAttributes[reelIndex][j].action = SymbolTeasingActions.IMPACT;
                                }
                            }
                        }
                    } else {
                        for (let j = 0; j < this.stoppedSymbolsArray[reelIndex].symbols.length; j++) {
                            if (this.stoppedSymbolsArray[reelIndex].symbols[j]) {
                                if (this.stoppedSymbolsArray[reelIndex].symbols[j] === this.teasingSymbol) {
                                    this.symbolsTeasingAttributes[reelIndex][j].action = SymbolTeasingActions.NORMAL;
                                }
                            }
                        }
                    }

                    break;
                case 1:
                    if (countOfSymbol > 1) {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.IMPACT_TEASE;
                                    }
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NOWIN;
                                    }
                                }
                            }
                        }
                    }

                    break;
                case 2:
                    if (countOfSymbol > 2) {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        if (i == reelIndex) {
                                            this.symbolsTeasingAttributes[i][j].action =
                                                SymbolTeasingActions.IMPACT_TEASE;
                                        } else {
                                            this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        this.teasingEnabled = false;
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                                }
                            }
                        }
                    }
                    break;
                case 3:
                    if (countOfSymbol > 3) {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        if (i == reelIndex) {
                                            this.symbolsTeasingAttributes[i][j].action =
                                                SymbolTeasingActions.IMPACT_TEASE;
                                        } else {
                                            this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                        }
                                    }
                                }
                            }
                        }
                    } else if (countOfSymbol == 3) {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                    }
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                                }
                            }
                        }
                    }
                    break;
                case 4:
                    if (countOfSymbol > 4) {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        if (i == reelIndex) {
                                            this.symbolsTeasingAttributes[i][j].action =
                                                SymbolTeasingActions.IMPACT_TEASE;
                                        } else {
                                            this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                        }
                                    }
                                }
                            }
                        }
                    } else if (countOfSymbol == 3 || countOfSymbol == 4) {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    if (this.stoppedSymbolsArray[i].symbols[j] === this.teasingSymbol) {
                                        this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.TEASE;
                                    }
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i <= reelIndex; i++) {
                            for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                                if (this.stoppedSymbolsArray[i].symbols[j]) {
                                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                                }
                            }
                        }
                    }
                    break;
            }
        } else {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.stoppedSymbolsArray[i].symbols.length; j++) {
                    this.symbolsTeasingAttributes[i][j].action = SymbolTeasingActions.NORMAL;
                }
            }
        }

        return this.symbolsTeasingAttributes;
    }

    //******************************************************************************************************************
    //  REELS TEASING ANIMATIONS
    //******************************************************************************************************************

    /**
     * Start animating teasing layers.
     *
     * @param reelIndex
     */
    public animateTeasing(reelIndex: number): void {
        if (this.teasingEnabled) {
            //this.removeTeasing(false);

            if (this.reelsTeasingAttributes[reelIndex + 1] != null) {
                if (this.reelsTeasingAttributes[reelIndex + 1].action == ReelTeasingActions.TEASE) {
                    if (this.elementInstance["teasingFront"] != null) {
                        this.elementInstance["teasingFront"].alpha = 1;
                        this.elementInstance["teasingFront"].visible = true;
                        this.elementInstance["teasingFront"].x = this.reelX[reelIndex + 1];
                        this.elementInstance["teasingFront"].y = this.reelY[reelIndex + 1];
                        this.elementInstance["teasingFront"].goToCase("INIT");
                    }
                    if (this.elementInstance["teasingParticles"] != null) {
                        this.elementInstance["teasingParticles"].alpha = 1;
                        this.elementInstance["teasingParticles"].visible = true;
                        this.elementInstance["teasingParticles"].x = this.reelX[reelIndex + 1];
                        this.elementInstance["teasingParticles"].y = this.reelY[reelIndex + 1];
                        this.elementInstance["teasingParticles"].goToCase("INIT");
                    }

                    if (!this.wasPlayedTeaserSound) {
                        PlayList.play("SND_BaseFSTeaser");
                        this.wasPlayedTeaserSound = true;
                    }
                } else if (this.reelsTeasingAttributes[reelIndex + 1].action == ReelTeasingActions.SPIN_STOP) {
                    this.removeTeasing(false);
                }
            }

            let countSymbolsOnReelsAndRows = this.getCountSymbolsOnReelsAndRows(0, reelIndex, this.teasingSymbol);
            let countSymbolsOnCurrentReel = this.getCountSymbolsOnReelsAndRows(
                reelIndex,
                reelIndex,
                this.teasingSymbol,
            );

            if (countSymbolsOnCurrentReel) {
                if (countSymbolsOnReelsAndRows > 0 && countSymbolsOnReelsAndRows <= 3) {
                    PlayList.play("SND_SymScatterStop01");
                } else if (countSymbolsOnReelsAndRows > 3) {
                    PlayList.play("SND_SymScatterStop03");
                }
            }
        } else {
            this.removeTeasing(false);
        }
    }

    /**
     * Remove teasing animations.
     * In case of enought teasing symbols count win sound is played else fail sound is played.
     *
     * @param {boolean} noWin
     */
    public removeTeasing(noWin: boolean): void {
        if (noWin) {
            //PlayList.play('SND_BaseFSTeaserFail');
        }

        if (this.wasPlayedTeaserSound) {
            PlayList.stop("SND_BaseFSTeaser");

            if (this.countSymbolsOnReelsAndRows > this.minimumSymbolsForTeasing) {
                if (!this.wasPlayedTeaserWinSound) {
                    PlayList.play("SND_BaseFSTeaserWin");
                    this.wasPlayedTeaserWinSound = true;
                }
            } else {
                if (!this.wasPlayedTeaserFailSound) {
                    PlayList.play("SND_BaseFSTeaserFail");
                    this.wasPlayedTeaserFailSound = true;
                }
            }
        }

        if (this.elementInstance["teasingFront"] != null) {
            if (
                this.elementInstance["teasingFront"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingFront"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingFront"].goToCase("OUTRO");
            }
        }
        if (this.elementInstance["teasingParticles"] != null) {
            if (
                this.elementInstance["teasingParticles"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingParticles"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingParticles"].goToCase("OUTRO");
            }
        }
    }

    public finishTeasing(): void {
        super.finishTeasing();

        this.canPlayTeaserSound = false;
        this.wasPlayedTeaserSound = false;

        if (this.elementInstance["teasingFront"] != null) {
            if (
                this.elementInstance["teasingFront"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingFront"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingFront"].goToCase("OUTRO");
            }
        }
        if (this.elementInstance["teasingParticles"] != null) {
            if (
                this.elementInstance["teasingParticles"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingParticles"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingParticles"].goToCase("OUTRO");
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/TeasingBonus.ts
 **/